import {
  useGetETSTicketsCreatorsQuery,
  useGetETSTicketsQuery,
} from 'gcs-common/clients/api/entities/tickets/tickets-api';
import {
  type ETSTicketsFilters,
  convertETSTicketsFiltersToQuery,
  useETSTicketsQueryParams,
} from 'gcs-common/clients/api/entities/tickets/tickets-api-helpers';
import { UserType } from 'gcs-common/slices/administration/administrationUsers/administrationUsersConstants';
import { getCurrentUserId } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { TicketDashboardTabNames } from 'gcs-common/slices/tickets/ticketsConstants';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import GroupedSelect from '../../../../GroupedSelect/GroupedSelect';

const MITARBEITER = 'Mitarbeiter';
const KUNDEN = 'KUNDEN';

const CreatorFilter = () => {
  const { etsTicketsfilters, setETSTicketsQueryParams } = useETSTicketsQueryParams();
  const currentUserId: string = useSelector(getCurrentUserId);
  const [resetCreator, setResetCreator] = useState(false);

  useEffect(() => {
    if (!etsTicketsfilters.creatorIds && etsTicketsfilters.tab !== TicketDashboardTabNames.NOT_LISTED) {
      setETSTicketsQueryParams(
        {
          creatorIds: currentUserId,
        },
        false,
      );
    }
  }, []);

  const { creatorIds } = etsTicketsfilters;
  const {
    data: ticketsData,
    isSuccess,
    isFetching,
  } = useGetETSTicketsQuery({
    query: convertETSTicketsFiltersToQuery(etsTicketsfilters),
  });
  const data = ticketsData ? ticketsData.data : undefined;

  const { data: creatorsData } = useGetETSTicketsCreatorsQuery();
  const creators = creatorsData ? creatorsData.creators : [];
  const loaded = creators.length > 0;

  useEffect(() => {
    // if the current creators have no tickets, remove the creators from the filters so other tickets show up
    if (isSuccess && !resetCreator && etsTicketsfilters.creatorIds && (!data || data.length === 0)) {
      setResetCreator(true);
      setETSTicketsQueryParams({
        creatorIds: 'None',
      });
    }
  }, [isSuccess]);

  const handleChange = (creatorIds: string[]) => {
    setCreatorIdsFilter(creatorIds.map((x) => encodeURIComponent(x)).join(','));
  };

  const setCreatorIdsFilter = (creatorIds: ETSTicketsFilters['creatorIds']) => {
    setETSTicketsQueryParams({
      creatorIds: creatorIds || 'None',
    });
  };

  const options = creators.map((c) => ({
    label: c.friendlyName,
    value: c.id,
    group: c.userType === UserType.AGENT ? MITARBEITER : KUNDEN,
  }));

  const groups = [MITARBEITER, KUNDEN];

  const selectedOptions = creatorIds === 'None' ? [] : (creatorIds || '').split(',');

  return (
    <div className="w-[500px]">
      <GroupedSelect
        key={loaded ? 'true' : 'false'}
        name="ticketCreatorIds"
        groups={groups}
        selectedOptions={selectedOptions}
        options={options}
        isLoading={isFetching}
        isClearable
        handleChange={handleChange}
        placeholder="Ersteller"
        noOptionsMessage="Keine Ersteller gefunden"
        hideSelectedOptions={false}
      />
    </div>
  );
};

export default CreatorFilter;
